import request from '@/utils/request';

export function getExpressDetail(postId) {
  return request({
    url: 'Express/detail',
    params: {
      postId,
    },
  });
}

export function getExpressEntry() {
  return request({
    url: 'Express/entry',
  });
}
